namespace TabAurous.Sales {
    export namespace MaterialOutItemsService {
        export const baseUrl = 'Sales/MaterialOutItems';

        export declare function Create(request: Serenity.SaveRequest<MaterialOutItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MaterialOutItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MaterialOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/MaterialOutItems/Create",
            Update = "Sales/MaterialOutItems/Update",
            Delete = "Sales/MaterialOutItems/Delete",
            Retrieve = "Sales/MaterialOutItems/Retrieve",
            List = "Sales/MaterialOutItems/List",
            CustomList = "Sales/MaterialOutItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>MaterialOutItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
